import { createRoot } from 'react-dom/client';

import 'antd/dist/reset.css';
import 'assets/style.css';
import 'assets/tailwind.css';
import 'simplebar-react/dist/simplebar.min.css';

import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);

reportWebVitals();
